import React, { useEffect, useState, useContext } from "react";
import URLstateContext from "../../../provider/CommonContext";
import './NewsEquity.css';


function NewsEquity(props) {
  let getData;
  const { BaseURL } = useContext(URLstateContext);
  const [data, setData] = useState([]);
  let getCoCode = props.coCode;
  let getCompName = props.requestcompname;
  const [companyInfo, setCompanyInfo] = useState([]);                     

  let companyInformation;
  useEffect(() => {
    const newsUrl = BaseURL + "NewsEquity";
    if (props.coCode != "") {
      fetch(`${newsUrl}/${getCoCode}/5`)
        .then((response) => response.json())
        .then((data) => {
          getData = data.data;
          setData(getData);
          companyInformation = data.data;
          //console.log(data.data)
          setCompanyInfo(companyInformation);
          
        })
        .catch((error) => {
          // console.log("not found the api 1233333");
        });
    }
  }, [props.coCode]);
 
  const routeChange = (event) => {
    const fetchId = event.currentTarget.getAttribute('data-id');
    const fetchHead = event.currentTarget.getAttribute('data-head');
    window.open("/Detail-News/" + fetchId + "/" + fetchHead.replace(/ /g, '-').replace('&', 'and').replace('/', 'slash').replace('?', 'questionMark').replace('=', 'isEqualsTo').replace(/\./g,'').replace(':', 'colon').replace('%', 'Percent'), '_blank');
};

const clickMoreNews = () => {
  window.open("/CompanyProfile/Company-News/" + getCompName, '_blank');
}

  return (
    <>
      <section className="peer-sc">
        <div className='container table-boxNews'>
          <div className='row'>
            <div className='col-md-12'>
              <div className="MoreNewsDiv">
              <h3 className="mainHeadingNews">Company News</h3>
              {(data != null)?<span className="moreContentSnap" onClick={clickMoreNews} >See More</span>:''}
              </div>
              {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
              {data && data.map(
                ({ co_code, SNo, Heading, Date, Time, ArtText, memo }) => (

                  <div className="newsDiv">
                     
                        {/* <span>Read {text}</span> */}
                        <h6 className="newhead" onClick={routeChange} data-head={Heading} data-id={SNo}>{Heading} </h6>
                        <p> {(Date.split('T')[0])}  ({Time})</p><hr></hr>
                      
                  </div>
                ))}

            
            </div>

          </div>
        </div>
      </section>

    </>
  )
}

export default NewsEquity